// Кружки набора на плитке пикера (связи ассета, 06.10): сколько показать кружками, остальное — за «+N».
export const LINKS_SHOWN = 4

/** Ровно на один больше предела — показываем все: кружок «+1» занял бы столько же места, сколько сам кружок. */
export function splitLinks<T>(links: T[], shown = LINKS_SHOWN): { shown: T[]; rest: T[] } {
	if (links.length <= shown + 1) return { shown: links, rest: [] }
	return { shown: links.slice(0, shown), rest: links.slice(shown) }
}

/** Ширина ряда кружков (26px, наложение 6px) — чтобы пилюля голоса на той же линии не заходила под него. */
export function linksRowWidth(count: number, circle = 26, overlap = 6): number {
	return count <= 0 ? 0 : circle + (count - 1) * (circle - overlap)
}
